import React, { useState, useEffect } from "react";
import classes from "./Product.module.css";
import ProductCard from "./ProductCard";
import Loader from "../../components/Loader/Loader";
import axios from "axios";

function Product() {
  const [products, setproducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    axios
      .get("https://fakestoreapi.com/products")
      .then((res) => {
        setproducts(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);
  // console.log(products);
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <section className={classes.product_container}>
          {products.map((info) => {
            return (
              <ProductCard key={info.id} productInfo={info} renderAdd={true} />
            );
          })}
        </section>
      )}
    </>
  );
}

export default Product;
